<template>
    <div class="relative w-full h-[600px] overflow-hidden">
        <div class="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50 z-10"></div>
        <div class="relative w-full h-full">
            <img
                v-for="(image, index) in bannerImages"
                :key="index"
                :src="image"
                alt="Banner"
                class="absolute w-full h-full object-cover transition-all duration-1000 transform"
                :class="{
                    'opacity-100 scale-100': currentBannerIndex === index,
                    'opacity-0 scale-110': currentBannerIndex !== index
                }"
            />
        </div>
        <div class="absolute inset-0 flex items-center justify-center z-20">
            <div class="text-center text-white max-w-4xl mx-auto px-8">
                <h1 class="text-6xl font-bold mb-6 animate-fade-in-up">{{ title }}</h1>
                <p class="text-2xl opacity-90 animate-fade-in-up delay-100">{{ subtitle }}</p>
            </div>
        </div>
        <!-- 轮播指示器 -->
        <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
            <button
                v-for="(_, index) in bannerImages"
                :key="index"
                @click="currentBannerIndex = index"
                class="w-4 h-4 rounded-full transition-all duration-300 transform hover:scale-125 relative"
                :class="currentBannerIndex === index ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/75'"
            >
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const currentBannerIndex = ref(0)
const isTransitioning = ref(false)

defineProps<{
    title?: string
    subtitle?: string
}>()

const bannerImages = [
    '/images/54.jpg',
    '/images/23.png',
]

const nextSlide = () => {
    if (isTransitioning.value) return
    isTransitioning.value = true
    currentBannerIndex.value = (currentBannerIndex.value + 1) % bannerImages.length
    setTimeout(() => {
        isTransitioning.value = false
    }, 1000)
}

onMounted(() => {
    setInterval(nextSlide, 5000)
})
</script> 